import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';


function RefundPolicy() {

  
  return (
    <>
      <Box className="aboutBanner contactBanner" >
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="bannerText text-center refundHeading">
                <h1 className="mb-0">Refund Policy</h1>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className="refundPolicy">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left">
           
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                <h2 className="heading-h2">Eligibility for Refund:</h2>
                  <ul className="list list-numeric">
                  <li>Refunds are not available for locker bookings, and therefore, no refunds will be issued.</li>
                  <li>No refunds will be provided for no-show customers/users.</li>
                  </ul>

                  <h2 className="heading-h2">Refund Processing Time:</h2>
                  <ul className="list">
                  <li>Any refunds, if applicable, will be processed within 7-10 business days from the date of cancellation.</li>
                  </ul>

                  <h2 className="heading-h2">Refund Modes:</h2>
                  <ul className="list">
                  <li>Refunds will be credited to the original mode of payment used for booking.</li>
                  </ul>

                  <h2 className="heading-h2">Queries:</h2>
                  <ul className="list">
                  <li>For any queries or complaints, please write to <Link href="mailto:info@mandir.wiki">info@mandir.wiki</Link></li>
                  </ul>
            </Grid>
           
          
          </Grid>
        </Container>
      </Box>
    </>
  );
}
export default RefundPolicy;